module.exports = __webpack_public_path__ + "img/logo_colours.749f8a02.png";